import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import {
    DialogContent,
    Grid,
} from "@material-ui/core";
import colorsService from "../../../services/colors.service";
import colorCategoriesService from "../../../services/color-categories.service";

const FormWrapper = ({ children }) => (
    <DialogContent>
        {children}
        {/* <Grid container spacing={2} alignItems={"center"}>
      {children}
    </Grid> */}
    </DialogContent>
);

const schema = Yup.object().shape({
    colors: yupSchema.colors,
});

export default function SelectColorModal({ close, data, extra }) {

    const {
        id,
        colors = []
    } = data;

    const errorHandler = useErrorHandler();

    const [colorList, setColorList] = useState([]);

    const form = useMemo(
        () => [
            {
                _type: "container",
                name: "col1",
                _wrapper: (props) => <Grid item sm={12} md={12} xs={12} {...props} />,
                form: ({ setFieldValue }) => [
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "colors",
                        options: colorList.map(item => ({
                            ...item,
                            key: item.id,
                            value: item.id,
                        })),
                        label: "رنگ ها",
                        disableClearable: true,
                        multiple: true,
                        valueSelector: "value",
                        labelSelector: "name",
                        fast: false,
                    },
                ],
            }
        ],
        [colorList]
    );


    const initialValues = useMemo(() => {
        const obj = {
            colors: colors.map(item => item.id)
        };
        return obj;
    }, [colors]);

    const handleSubmit = async (_model, { setSubmitting }) => {
        const {
            colors
        } = _model

        let op = await colorCategoriesService.setColorToCategories(id, colors)
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    const getAPI = () => {
        colorsService.getColors()
            .then(res => {
                setColorList(res.data)
            })
    }

    useEffect(() => {
        getAPI()
    }, []);

    return (
        <DialogFormBuilder
            {...{
                close,
                title: "رنگ ها",
                data: colors.map(item => item.id),
                schema,
                initialValues,
                handleSubmit,
                form,
                formWrapper: FormWrapper,
                submitLabel: "ذخیره",
            }}
        />
    );
}
